import React from 'react';

const Loading = () => (
  <div className="fixed-loader-container">
    <div className="main-loader"/>
  </div>
)

export default Loading;